import config from '../config';
// import enLocale from 'element-ui/lib/locale/lang/en';
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import axios from 'axios';

// elementui 语言包
// const elementLocaleMessage = {
//   'zh-CN': zhLocale,
//   'en-US': enLocale
// };

const getMessage = (localeid, locale) => {
  return new Promise((resolve, reject) => {
    let { localesMessageUrl, elementLocaleMessage } = config.get();

    rt.get(localesMessageUrl + localeid)
      .then(res => {
        let elMessage = elementLocaleMessage[locale];
        // 合并 elementui 和业务语言包
        let message = Object.assign({}, res.LanguageConfigs, elMessage);
        // 缓存到 localStorage
        localStorage.setItem(locale, JSON.stringify(message));
        resolve(message);
      })
      .catch(() => {
        reject('get messages error');
      });
  });
};

const getLocales = () => {
  return new Promise((resolve, reject) => {
    let { localesUrl } = config.get();
    rt.get(localesUrl)
      .then(res => {
        let locales = res.map(item => {
          return {
            value: item.new_code,
            name: item.new_displayname,
            native: item.new_name,
            langid: item.new_langid
          };
        });
        resolve(locales);
      })
      .catch(() => {
        reject('get locales error');
      });
  });
};

const use = (Vue, i18n) => {
  let { defaultLocale, defaultLocaleId } = config.get();
  // localStorage 是否有用户设置的语种，有使用用户设置，没有使用默认设置；
  let locale = localStorage.getItem('i18nLocale') || defaultLocale;
  let localeid = localStorage.getItem('i18nLocaleid') || defaultLocaleId;

  // 获取所有支持语种，并缓存到 localStorage
  getLocales().then(res => {
    // 放置到 store 对象
    localStorage.setItem('locales', JSON.stringify(res));
  });

  // 根据默认语种 id 获取语言包；
  const message = getMessage(localeid, locale);
  message.then(res => {
    i18n.locale = locale;
    i18n.setLocaleMessage(locale, res);
  });

  // 设置请求头语言，通知后端
  axios.interceptors.request.use(function(config) {
    config.headers['Accept-Language'] = locale;
    return config;
  });
};

export default {
  install(Vue, opts) {
    const { i18n } = opts;
    Vue.prototype.$tx = (defaultValue, key) => {
      // 没有传入 key ，直接返回 defaultValue
      if (!key) return defaultValue;
      // i18n 方法存在，使用 i18nMethod 翻译
      if (i18n && i18n.t) {
        let value = i18n.t(key);
        return value || defaultValue;
      }
      return defaultValue;
    };

    // 存在多语言实例，根据配置获取多语言包和语种并缓存
    if (i18n) {
      use(Vue, i18n);
    }
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/locale-plugin.js